import type { TourModule } from '@modules/product-updates/tours/tourTypes';

export const PROSPECTION_MAP_ANCHORS = {
  layers: 'prospection-map-layers',
  valuations: 'prospection-map-valuations',
  cards: 'prospection-map-cards',
  map: 'prospection-map-canvas',
  resetNorth: 'prospection-map-reset-north',
  style: 'prospection-map-style',
  locate: 'prospection-map-locate',
} as const;

// The map orbits on ⌘ + drag on a Mac, Ctrl + drag elsewhere (the rotate
// handler in `ProspectionMapV2.tsx`).
const rotateKey = () =>
  typeof navigator !== 'undefined' &&
  /Mac|iPhone|iPad/i.test(navigator.platform || navigator.userAgent)
    ? '⌘'
    : 'Ctrl';

// The new prospection map (`ProspectionMapV2.tsx`). Plays on a user's first
// visit (campaign `prospection-map-first-visit`) and from "Show me" on
// `content/releases/prospection-map`.
export const prospectionMapTour: TourModule = {
  steps: t => [
    {
      anchor: PROSPECTION_MAP_ANCHORS.layers,
      title: t('Choose what the map shows'),
      body: t(
        'Turn layers on and off: recent valuations, past sales, energy certificates, parcels, your leads and notes.',
      ),
      placement: 'right-start',
    },
    {
      anchor: PROSPECTION_MAP_ANCHORS.valuations,
      title: t('Owners thinking about selling'),
      body: t(
        'Valuations shows owners who recently valued their property online. Filter them by property type, intent and time period.',
      ),
      placement: 'right',
    },
    {
      anchor: PROSPECTION_MAP_ANCHORS.cards,
      title: t('The pins on the map, as cards'),
      body: t(
        'The list follows the pins visible on the map as you move it. Click a card to zoom to its pin.',
      ),
      placement: 'right-start',
    },
    {
      anchor: PROSPECTION_MAP_ANCHORS.map,
      title: t('Click any parcel'),
      body: t(
        'Click a spot on the map to see its details, with the parcel outlined where available. From there, Add note or Create lead.',
      ),
      placement: 'bottom',
    },
    {
      anchor: PROSPECTION_MAP_ANCHORS.resetNorth,
      title: t('Rotate and tilt'),
      body: t(
        'Hold {{key}} and drag the map to rotate it and change the angle. This button turns it back to north.',
        { key: rotateKey() },
      ),
      placement: 'left',
    },
    {
      anchor: PROSPECTION_MAP_ANCHORS.style,
      title: t('Map or satellite'),
      body: t(
        'Switch to Satellite for a 3D aerial view of the buildings and gardens.',
      ),
      placement: 'bottom-end',
    },
    {
      anchor: PROSPECTION_MAP_ANCHORS.locate,
      title: t('Prospect on the go'),
      body: t('Show your position to see the opportunities around you.'),
      placement: 'left',
    },
  ],
  resolvePath: async () => '/prospection',
};
